import SpriteSymbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "italic",
  "use": "italic-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 24 24\" id=\"italic\">\n<path d=\"M19,5h-9C9.4,5,9,4.6,9,4s0.4-1,1-1h9c0.6,0,1,0.4,1,1S19.6,5,19,5z\" />\n<path d=\"M14,21H5c-0.6,0-1-0.4-1-1s0.4-1,1-1h9c0.6,0,1,0.4,1,1S14.6,21,14,21z\" />\n<path d=\"M9,21c-0.1,0-0.2,0-0.4-0.1c-0.5-0.2-0.8-0.8-0.6-1.3l6-16c0.2-0.5,0.8-0.8,1.3-0.6c0.5,0.2,0.8,0.8,0.6,1.3l-6,16\n\tC9.8,20.8,9.4,21,9,21z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol